
import { useQuery } from "@tanstack/react-query";
import { fetchSuggestedTasks } from "../database-suggested-tasks";
import { useUser } from "@/hooks/auth/use-user";

export function useSuggestedTasksQuery(goalId: string) {
  const { user } = useUser();
  return useQuery({
    queryKey: ["suggestedTasks", user?.id, goalId],
    queryFn: () => {
      if (!user) throw new Error("Not signed in");
      return fetchSuggestedTasks(goalId, user.id);
    },
    enabled: Boolean(user && goalId),
  });
}
